var mymap = L.map("mapid", {
    scrollWheelZoom: false,
}).setView([-39.2764751, -71.9809511], 14);

var icon = L.icon({
    iconUrl: "./../images/notros-de-alicura/marker-icon-2x.png",
    shadowUrl: "",

    iconSize: [25, 41], // size of the icon
    shadowSize: [0, 0], // size of the shadow
    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
    shadowAnchor: [4, 62], // the same for the shadow
    popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
});

var marker = L.marker([-39.2864751, -71.9909511], { icon: icon })
    .addTo(mymap)
    .bindPopup("Condominio Los Notros de Alicura")
    .openPopup();

L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    attribution: '&copy; <a href="https://openstreetmap.org/copyright">baluart.cl</a>'
}).addTo(mymap);

